<template>
  <teleport to="body">
    <modal-base
      :show="modalActive"
      hide-submit
      hide-cancel
      min-width="min(600px, 95vw)"
      :title="mostrandoMotivos ? $t('titulos.motivosCancelacion') : $t('reserva.reservasCancelar')"
      @on-close="close">
      <template #body>
        <CancelarReservas :grupo="grupo" @motivos-cancelacion="mostrandoMotivos = $event" @close="close" />
      </template>
    </modal-base>
  </teleport>
</template>

<script setup>
  import ModalBase from '@/components/modales/ModalBase';
  import CancelarReservas from '@/components/modales/CancelarReservas.vue';
  import { ref } from 'vue';

  defineProps({
    grupo: {
      type: Object,
      default: null,
    },
    modalActive: {
      type: Boolean,
      default: null,
    },
  });

  const emit = defineEmits(['close-modal']);
  const mostrandoMotivos = ref(false);

  const close = () => {
    mostrandoMotivos.value = false;
    emit('close-modal');
  };
</script>
